export const Types = {
  SAVE_LIST_USER_CHECKIN: "SAVE_LIST_USER_CHECKIN",
  SAVE_DETAIL_USER_CHECKIN: "SAVE_DETAIL_USER_CHECKIN",
  SAVE_CHECKIN_FREE_CONFIG: "SAVE_CHECKIN_FREE_CONFIG",
};
